import { Injectable } from "@angular/core";
import { Arquivo } from '@tivic-team/manager-ts/dist/grl';
import { ConcessaoArquivoDTO } from "app/model/dtos/mob/concessao-arquivo.dto";
import { DocumentoArquivoDTO } from "app/model/dtos/ptc/documento-arquivo.dto";
import { HttpDelete, HttpGet, HttpPost, HttpResponse, JSONData, Quark, Url } from "sol-request-angular/dist/comunicacao";
import { IFilter } from "sol-request-angular/dist/comunicacao/interfaces/IFilter";
import { environmentv3 } from "src/environments/environmentv3";
import { ApiController } from "../api-controller.interface";

@Injectable()
export class ConcessaoArquivoController implements ApiController<ConcessaoArquivoDTO>{

    constructor() { }

    find(filters?: IFilter): Promise<ConcessaoArquivoDTO[]> {
        throw new Error("Method not implemented.");
    }
    get(id: number): Promise<ConcessaoArquivoDTO> {
        throw new Error("Method not implemented.");
    }

    create(entity: ConcessaoArquivoDTO): Promise<ConcessaoArquivoDTO> {
        let request = new Quark(
            new HttpPost({
                url: new Url({
                    id: 'mob/concessaoarquivo/:cdConcessao',
                    environment: environmentv3,
                    pathParams: new JSONData({
                        cdConcessao: entity.cdConcessao,
                    })
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse(
                new ConcessaoArquivoDTO()
            )
        );

        return request.call();
    }

    update(entity: ConcessaoArquivoDTO): Promise<ConcessaoArquivoDTO> {
        throw new Error("Method not implemented.");
    }

    getArquivosByConcessao(filtros?: IFilter, id?: number): Promise<DocumentoArquivoDTO[]> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/concessaoarquivo/:cdConcessao',
                    environment: environmentv3,
                    pathParams: new JSONData({
                        cdConcessao: id
                    }),
                    filter: filtros
                }),
            }),
            new HttpResponse(new Array<ConcessaoArquivoDTO>())
        );

        return request.call();
    }

    downloadArquivo(id: number): Promise<Arquivo> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/concessaoarquivo/:cdArquivo/download',
                    environment: environmentv3,
                    pathParams: new JSONData({
                        cdArquivo: id
                    }),
                }),
            }),
            new HttpResponse(new Arquivo())
        );

        return request.call();
    }

    delete(entity: DocumentoArquivoDTO, cdConcessao: number): Promise<DocumentoArquivoDTO> {
        let request = new Quark(
            new HttpDelete({
                url: new Url({
                    id: 'mob/concessaoarquivo/:cdConcessao/:cdArquivo/:cdDocumento/:cdPessoa/:cdTipoDocumentacao',
                    environment: environmentv3,
                    pathParams: new JSONData({
                        cdConcessao: cdConcessao, 
                        cdArquivo: entity.cdArquivo,
                        cdDocumento: entity.cdDocumento,
                        cdPessoa: entity.cdPessoa,
                        cdTipoDocumentacao: entity.cdTipoDocumentacao
                        
                    })
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse(
                new ConcessaoArquivoDTO()
            )
        );
        return request.call();
    }
}